import { EventSchema } from '@optimizely/opal-app-companion';

// Product types configuration
export const productTypes = Object.entries(EventSchema.shape).map(
  ([productKey, productSchema]) => ({
    value: productKey,
    label: productSchema.meta()?.title ?? productKey,
  })
);

// Event types configuration derived from EventSchema
export const eventTypes = Object.entries(EventSchema.shape).flatMap(([productKey, productSchema]) =>
  Object.entries(productSchema.shape).map(([eventKey, eventSchema]) => ({
    value: `${productKey}.${eventKey}`,
    label: eventSchema.meta()?.title ?? eventKey,
    product: productKey,
  }))
);

// Utility function to get event type label
export const getEventTypeLabel = (value: string) => {
  const eventType = eventTypes.find(type => type.value === value);
  return eventType ? eventType.label : value; // fallback to value if not found
};

export const getEventTypeProduct = (value: string) => {
  const eventType = eventTypes.find(type => type.value === value);
  return eventType
    ? (productTypes.find(product => product.value === eventType.product)?.label ?? null)
    : null;
};
